import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {
  PresignedResponse,
  UploadEvent,
} from '@models/ncx/pre-signed-response';
import { ThumbnailService } from '@services/thumbnails/thumbnail.service';
import { map, switchMap } from 'rxjs';
import { Observable } from 'rxjs-compat';
import { CommonService } from 'src/app/services/common-service';

@Injectable({
  providedIn: 'root',
})
export class AttachmentUploadService {
  constructor(
    private commons: CommonService,
    private thumbnailService: ThumbnailService,
    private http: HttpClient
  ) {}

  getPresignedResponse(
    fileName: string,
    prefix: string,
    entityType: string,
    headers: HttpHeaders
  ): Observable<PresignedResponse> {
    const baseUrl = `${this.commons.getAPIEndpoint()}/ncx-gateway`;
    const attachmentUrl = environment.getAttachmentUrlApi;

    const apiUrl = `${baseUrl}${attachmentUrl}?entityId=${prefix}&entityType=${entityType}&fileName=${fileName}`;

    return this.http.get<PresignedResponse>(apiUrl, {
      headers,
    });
  }

  uploadAttachment(
    file: File,
    prefix: string,
    entityType: string,
    headers: HttpHeaders
  ): Observable<UploadEvent> {
    const presignedUrl = this.getPresignedResponse(
      file.name,
      prefix,
      entityType,
      headers
    );

    return presignedUrl.pipe(
      switchMap((response: PresignedResponse) => {
        const presignedUrlForAttachment = response.attachmentUploadUrl;
        const attachmentData = response.attachment;

        this.thumbnailService.generateThumbnail(
          file,
          attachmentData.attachmentPreview,
          (thumbnail: File) =>
            this.uploadPreviewThumbnail(
              thumbnail,
              response.attachmentPreviewUploadUrl
            )
        );

        return this.http
          .put(presignedUrlForAttachment, file, {
            reportProgress: true,
            observe: 'events',
            headers: {
              'Content-Type': file.type,
            },
          })
          .pipe(
            map((event) => ({
              attachmentData,
              httpEvent: event,
            }))
          );
      })
    );
  }

  private uploadPreviewThumbnail(thumbnail: File, previewUploadUrl: string) {
    if (thumbnail) {
      this.http
        .put(previewUploadUrl, thumbnail, {
          headers: {
            'Content-Type': thumbnail.type || 'image/jpeg',
          },
        })
        .subscribe({
          next: () => {
            console.log('Thumbnail uploaded successfully');
          },
          error: (err) => {
            console.error('Error uploading thumbnail:', err);
          },
        });
    }
  }
}
